var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Adapter, AdapterState, isInBrowser, WalletReadyState, WalletSignMessageError, WalletNotFoundError, WalletDisconnectedError, WalletConnectionError, WalletSignTransactionError, WalletGetNetworkError, } from '@tronweb3/tronwallet-abstract-adapter';
import { getNetworkInfoByTronWeb } from '@tronweb3/tronwallet-adapter-tronlink';
import { openTrustWallet, supportTrust } from './utils.js';
export const TrustAdapterName = 'Trust';
export class TrustAdapter extends Adapter {
    constructor(config = {}) {
        super();
        this.name = TrustAdapterName;
        this.url = 'https://trustwallet.com';
        this.icon = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTgiIGhlaWdodD0iNjUiIHZpZXdCb3g9IjAgMCA1OCA2NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgOS4zODk0OUwyOC44OTA3IDBWNjUuMDA0MkM4LjI1NDUgNTYuMzM2OSAwIDM5LjcyNDggMCAzMC4zMzUzVjkuMzg5NDlaIiBmaWxsPSIjMDUwMEZGIi8+CjxwYXRoIGQ9Ik01Ny43ODIyIDkuMzg5NDlMMjguODkxNSAwVjY1LjAwNDJDNDkuNTI3NyA1Ni4zMzY5IDU3Ljc4MjIgMzkuNzI0OCA1Ny43ODIyIDMwLjMzNTNWOS4zODk0OVoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8yMjAxXzY5NDIpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMjIwMV82OTQyIiB4MT0iNTEuMzYxNSIgeTE9Ii00LjE1MjkzIiB4Mj0iMjkuNTM4NCIgeTI9IjY0LjUxNDciIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agb2Zmc2V0PSIwLjAyMTEyIiBzdG9wLWNvbG9yPSIjMDAwMEZGIi8+CjxzdG9wIG9mZnNldD0iMC4wNzYyNDIzIiBzdG9wLWNvbG9yPSIjMDA5NEZGIi8+CjxzdG9wIG9mZnNldD0iMC4xNjMwODkiIHN0b3AtY29sb3I9IiM0OEZGOTEiLz4KPHN0b3Agb2Zmc2V0PSIwLjQyMDA0OSIgc3RvcC1jb2xvcj0iIzAwOTRGRiIvPgo8c3RvcCBvZmZzZXQ9IjAuNjgyODg2IiBzdG9wLWNvbG9yPSIjMDAzOEZGIi8+CjxzdG9wIG9mZnNldD0iMC45MDI0NjUiIHN0b3AtY29sb3I9IiMwNTAwRkYiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K';
        this._readyState = isInBrowser() ? WalletReadyState.Loading : WalletReadyState.NotFound;
        this._state = AdapterState.Loading;
        this.messageHandler = (e) => {
            var _a, _b, _c;
            const message = (_a = e.data) === null || _a === void 0 ? void 0 : _a.message;
            if (!message) {
                return;
            }
            if (message.action === 'accountsChanged') {
                setTimeout(() => {
                    var _a;
                    const preAddr = this.address || '';
                    if ((_a = this._wallet) === null || _a === void 0 ? void 0 : _a.ready) {
                        const address = message.data.address;
                        this.setAddress(address);
                        this.setState(AdapterState.Connected);
                    }
                    else {
                        this.setAddress(null);
                        this.setState(AdapterState.Disconnect);
                    }
                    const address = this.address || '';
                    if (address !== preAddr) {
                        this.emit('accountsChanged', this.address || '', preAddr);
                    }
                    if (!preAddr && this.address) {
                        this.emit('connect', this.address);
                    }
                    else if (preAddr && !this.address) {
                        this.emit('disconnect');
                    }
                }, 200);
            }
            else if (message.action === 'connect') {
                const isCurConnected = this.connected;
                const preAddress = this.address || '';
                const address = ((_c = (_b = this._wallet.tronWeb) === null || _b === void 0 ? void 0 : _b.defaultAddress) === null || _c === void 0 ? void 0 : _c.base58) || '';
                this.setAddress(address);
                this.setState(AdapterState.Connected);
                if (!isCurConnected) {
                    this.emit('connect', address);
                }
                else if (address !== preAddress) {
                    this.emit('accountsChanged', this.address || '', preAddress);
                }
            }
            else if (message.action === 'disconnect') {
                this.setAddress(null);
                this.setState(AdapterState.Disconnect);
                this.emit('disconnect');
            }
        };
        this._checkPromise = null;
        this._updateWallet = () => {
            var _a, _b;
            let state = this.state;
            let address = this.address;
            if (supportTrust()) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this._wallet = window.trustwallet.tronLink;
                this._listenEvent();
                address = ((_b = (_a = this._wallet.tronWeb) === null || _a === void 0 ? void 0 : _a.defaultAddress) === null || _b === void 0 ? void 0 : _b.base58) || null;
                state = this._wallet.ready ? AdapterState.Connected : AdapterState.Disconnect;
            }
            else {
                this._wallet = null;
                address = null;
                state = AdapterState.NotFound;
            }
            this.setAddress(address);
            this.setState(state);
        };
        const { checkTimeout = 2 * 1000, openUrlWhenWalletNotFound = true, openAppWithDeeplink = true } = config;
        if (typeof checkTimeout !== 'number') {
            throw new Error('[TrustAdapter] config.checkTimeout should be a number');
        }
        this.config = {
            checkTimeout,
            openAppWithDeeplink,
            openUrlWhenWalletNotFound,
        };
        this._connecting = false;
        this._wallet = null;
        this._address = null;
        if (!isInBrowser()) {
            this._readyState = WalletReadyState.NotFound;
            this.setState(AdapterState.NotFound);
            return;
        }
        if (supportTrust()) {
            this._readyState = WalletReadyState.Found;
            this._updateWallet();
        }
        else {
            this._checkWallet().then(() => {
                if (this.connected) {
                    this.emit('connect', this.address || '');
                }
            });
        }
    }
    get address() {
        return this._address;
    }
    get state() {
        return this._state;
    }
    get readyState() {
        return this._readyState;
    }
    get connecting() {
        return this._connecting;
    }
    /**
     * Get network information used by Trust.
     * @returns {Network} Current network information.
     */
    network() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this._checkWallet();
                if (this.state !== AdapterState.Connected)
                    throw new WalletDisconnectedError();
                const wallet = this._wallet;
                if (!wallet || !wallet.tronWeb)
                    throw new WalletDisconnectedError();
                try {
                    return yield getNetworkInfoByTronWeb(wallet.tronWeb);
                }
                catch (e) {
                    throw new WalletGetNetworkError(e === null || e === void 0 ? void 0 : e.message, e);
                }
            }
            catch (e) {
                this.emit('error', e);
                throw e;
            }
        });
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                this.checkIfopenTrustWallet();
                if (this.connected || this.connecting)
                    return;
                yield this._checkWallet();
                if (this.state === AdapterState.NotFound) {
                    if (this.config.openUrlWhenWalletNotFound !== false && isInBrowser()) {
                        window.open(this.url, '_blank');
                    }
                    throw new WalletNotFoundError();
                }
                if (!this._wallet)
                    return;
                this._connecting = true;
                const wallet = this._wallet;
                try {
                    const res = yield wallet.request({ method: 'tron_requestAccounts' });
                    if (!res) {
                        throw new WalletConnectionError('Request connect error.');
                    }
                    if (res.code === 4000) {
                        throw new WalletConnectionError('The same DApp has already initiated a request to connect to trustwallet, and the pop-up window has not been closed.');
                    }
                    if (res.code === 4001) {
                        throw new WalletConnectionError('The user rejected connection.');
                    }
                }
                catch (error) {
                    throw new WalletConnectionError(error === null || error === void 0 ? void 0 : error.message, error);
                }
                const address = ((_a = wallet.tronWeb.defaultAddress) === null || _a === void 0 ? void 0 : _a.base58) || '';
                this.setAddress(address);
                this.setState(AdapterState.Connected);
                this._listenEvent();
                this.connected && this.emit('connect', this.address || '');
            }
            catch (error) {
                this.emit('error', error);
                throw error;
            }
            finally {
                this._connecting = false;
            }
        });
    }
    disconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this._stopListenEvent();
            if (this.state !== AdapterState.Connected) {
                return;
            }
            this.setAddress(null);
            this.setState(AdapterState.Disconnect);
            this.emit('disconnect');
        });
    }
    signTransaction(transaction, privateKey) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const wallet = yield this.checkAndGetWallet();
                try {
                    return yield wallet.tronWeb.trx.sign(transaction, privateKey);
                }
                catch (error) {
                    if (error instanceof Error) {
                        throw new WalletSignTransactionError(error.message, error);
                    }
                    else {
                        throw new WalletSignTransactionError(error, new Error(error));
                    }
                }
            }
            catch (error) {
                this.emit('error', error);
                throw error;
            }
        });
    }
    multiSign(transaction, privateKey, permissionId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const wallet = yield this.checkAndGetWallet();
                try {
                    return yield wallet.tronWeb.trx.multiSign(transaction, privateKey, permissionId);
                }
                catch (error) {
                    if (error instanceof Error) {
                        throw new WalletSignTransactionError(error.message, error);
                    }
                    else {
                        throw new WalletSignTransactionError(error, new Error(error));
                    }
                }
            }
            catch (error) {
                this.emit('error', error);
                throw error;
            }
        });
    }
    signMessage(message, privateKey) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const wallet = yield this.checkAndGetWallet();
                try {
                    return yield wallet.tronWeb.trx.signMessageV2(message, privateKey);
                }
                catch (error) {
                    if (error instanceof Error) {
                        throw new WalletSignMessageError(error.message, error);
                    }
                    else {
                        throw new WalletSignMessageError(error, new Error(error));
                    }
                }
            }
            catch (error) {
                this.emit('error', error);
                throw error;
            }
        });
    }
    checkAndGetWallet() {
        return __awaiter(this, void 0, void 0, function* () {
            this.checkIfopenTrustWallet();
            yield this._checkWallet();
            if (this.state !== AdapterState.Connected)
                throw new WalletDisconnectedError();
            const wallet = this._wallet;
            if (!wallet || !wallet.tronWeb)
                throw new WalletDisconnectedError();
            return wallet;
        });
    }
    _listenEvent() {
        this._stopListenEvent();
        window.addEventListener('message', this.messageHandler);
    }
    _stopListenEvent() {
        window.removeEventListener('message', this.messageHandler);
    }
    checkIfopenTrustWallet() {
        if (this.config.openAppWithDeeplink === false) {
            return;
        }
        if (openTrustWallet()) {
            throw new WalletNotFoundError();
        }
    }
    /**
     * check if wallet exists by interval, the promise only resolve when wallet detected or timeout
     * @returns if trustwallet exists
     */
    _checkWallet() {
        if (this.readyState === WalletReadyState.Found) {
            return Promise.resolve(true);
        }
        if (this._checkPromise) {
            return this._checkPromise;
        }
        const interval = 100;
        const maxTimes = Math.floor(this.config.checkTimeout / interval);
        let times = 0, timer;
        this._checkPromise = new Promise((resolve) => {
            const check = () => {
                times++;
                const isSupport = supportTrust();
                if (isSupport || times > maxTimes) {
                    timer && clearInterval(timer);
                    this._readyState = isSupport ? WalletReadyState.Found : WalletReadyState.NotFound;
                    this._updateWallet();
                    this.emit('readyStateChanged', this.readyState);
                    resolve(isSupport);
                }
            };
            timer = setInterval(check, interval);
            check();
        });
        return this._checkPromise;
    }
    setAddress(address) {
        this._address = address;
    }
    setState(state) {
        const preState = this.state;
        if (state !== preState) {
            this._state = state;
            this.emit('stateChanged', state);
        }
    }
}
//# sourceMappingURL=adapter.js.map